import { render, staticRenderFns } from "./BillsConstructionPortlet.vue?vue&type=template&id=320e7ca0&"
import script from "./BillsConstructionPortlet.vue?vue&type=script&lang=js&"
export * from "./BillsConstructionPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports